import { render, staticRenderFns } from "./social-btns.vue?vue&type=template&id=365d28be&scoped=true"
import script from "./social-btns.vue?vue&type=script&lang=js"
export * from "./social-btns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365d28be",
  null
  
)

export default component.exports